import React from "react";
import ReportByPartners from "../../../features/reports/rcs/report-by-carriers/components/ReportByPartners";
const _ReportsByPartners = () => {
  return (
    <div className="my-1">
      <h2>Reporte RCS por Partners</h2>
      <ReportByPartners />
    </div>
  );
};

export default _ReportsByPartners;
